import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorSpanish } from '../shared/paginatorIntl';
import { MaterialModule } from "./material.module";

import { FeatherIconsModule } from "./components/feather-icons/feather-icons.module";

import { DespliegaresultadosComponent } from "../resultados/despliegaresultados/despliegaresultados.component";

//Pipes
import { SexoPipe } from '../shared/pipes/sexo.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgbModule,
        RichTextEditorModule,
        MaterialModule,
        SexoPipe,
        DespliegaresultadosComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgbModule,
        MaterialModule,
        FeatherIconsModule,
        SexoPipe,
        DespliegaresultadosComponent
    ],
    providers: [
        {
            provide: MatPaginatorIntl,
            useClass: MatPaginatorSpanish
        },
    ]
})
export class SharedModule {}
